// extracted by mini-css-extract-plugin
export default {"clrBorderLight":"#e0e0e0","wrapper":"Divider_wrapper__JpjIC"};